import { gql } from 'apollo-boost';

export const CREATE_ADMIN_VIDEO_FRAME_ANALYSIS_DIAGNOSTIC_EXPORT = gql`
    mutation CreateAdminVideoFrameAnalysisDiagnosticExport($data: CreateAdminVideoFrameAnalysisDiagnosticExportInput!) {
        createAdminVideoFrameAnalysisDiagnosticExport(data: $data) {
            resultUrl
            expiresAt
            fileCount
        }
    }
`;
